// The First Short Film Festival, for people (sim-server world/Festival.js is the town's side).
//
// Sam, 4 Nov: "we are going to need terms and a way for people to submit their movies...lets make it strict so we don't
// get flooded ... At all posters for the movie night, lets have an action button with a drawer that comes up to show about
// the film festival, the rules and how to submit". Who: "only someone he knows". Each one: "You approve each". How many:
// "One each, 20 in all". And, asked whether people can make theirs with AI as he does: yes, said plainly in the rules.
//
// One place for the words and the limits, read by the drawer (components/ui/FestivalDrawer.jsx), the upload door
// (app/api/festival/upload) and the entry door (app/api/festival). The town checks the same limits again.

import { AD_SLOTS, EVENT_SLOTS } from './ads/slots.js'

export const FESTIVAL_TITLE = 'The First Short Film Festival'
export const CLOSES_AT = Date.parse('2026-11-13T00:00:00Z')
export const NIGHT_AT = Date.parse('2026-11-14T20:00:00Z')
export const POSTER = '/images/posters/festival_2026.webp'

// he has kept at least this many things of yours: someone he knows (the same rung as voting)
export const KNOWN_MIN = 1
export const MOST_FILMS = 20
export const SECONDS = [5, 60]
export const MAX_BYTES = 50 * 1024 * 1024
export const TITLE_MAX = 60
export const LINE_MAX = 200
export const VIDEO_TYPES = ['video/mp4', 'video/quicktime', 'video/webm']
export const STILL_TYPES = ['image/png', 'image/jpeg']
// the stills sheet made in the entrant's browser: twelve frames, four across, in the order they play
export const SHEET = { cols: 4, rows: 3, w: 320, h: 180 }

// where the festival's posters hang: walk up to one and the button comes up
export const POSTER_SPOTS = [
  ...AD_SLOTS.filter((s) => ['poster_laundrette', 'poster_coffee', 'poster_phone'].includes(s.id)),
  ...EVENT_SLOTS.filter((s) => s.id === 'cinema_bill'),
].map((s) => ({ id: s.id, x: s.position[0], z: s.position[2] }))
export const NEAR = 8

export const ABOUT = [
  `The town's cinema is holding its first short film festival, presented with Runway. On festival night, Saturday 14 November from 8pm (UK time), Pino goes to the cinema and watches every film entered, one after another, after the opening film: the Lumière brothers' train arriving at La Ciotat, from 1896, one of the first films ever shown.`,
  `Pino can enter too. He'd have to find the dream cam in the tech shop window first, and nobody has told him it's there.`,
  `He watches each film the way he watches his own: its stills, in the order they play, with its title and the line you write about it. It's a silent festival, so nothing is lost.`,
]

export const RULES = [
  'You can enter if Pino knows you: he has kept at least one thing you left him at the shrine.',
  'One film each. Twenty films in all: entries close early if it fills up.',
  'Entries close at midnight (UK) at the end of Thursday 12 November.',
  'Silent: 5 to 60 seconds. Any sound is never played.',
  'mp4, mov or webm, up to 50 MB. A title of up to 60 characters, and one line about it of up to 200, in your own words.',
  'Make it however you like: a camera, drawings, animation, or AI tools (Pino makes his with Runway). It has to be yours, and you need the right to use everything in it.',
  'No real people who haven\'t agreed to be in it. Nothing sexual, hateful, cruel or against the law. No one else\'s film, music video or advert.',
  'A person watches every film before it goes in, and may say no to any film. Pino only hears about a film once it is in.',
  'You can take your film back out yourself, any time before festival night.',
]

export const TERMS = [
  'By entering, you confirm that you made the film and that you own, or have permission for, everything in it, including anything made with AI tools, used within those tools\' own terms.',
  'You keep the copyright. You give Pino\'s World (pinos.world) a free, non-exclusive, worldwide licence to show the film, its stills, its title, your line and your username in Pino\'s town, on pinos.world, on festival night and in posts about the festival.',
  'Pino sees your film as its stills, with your title and your line, and may say, write or make things about it. What he says is his own.',
  'Your username is shown with your film. Your email is never shown.',
  'We may refuse or take down any film at any time, without giving a reason. There are no prizes and no payments.',
]

/** A blob address this site's store gave out, under festival/. */
export function isFestivalBlob(url) {
  try {
    const u = new URL(String(url))
    return u.protocol === 'https:' && /\.public\.blob\.vercel-storage\.com$/.test(u.hostname) && u.pathname.startsWith('/festival/')
  } catch { return false }
}
